import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

declare global {
  interface Window {
    OneSignalDeferred: any;
  }
}
// Angular Fire
import { AngularFireAuth } from 'angularfire2/auth';
import { UsuariosPersonalService } from '../../services/usuarios-personal.service';

@Component({
	templateUrl: './login.component.html'
})

export class LoginComponent {

	constructor(
		private afAuth: AngularFireAuth,
		private usuariosService: UsuariosPersonalService,
		public route: Router,
		private location: Location) {

	}
    planeacionOmantenimiento = false;
    showLoader = false;
    OneSignalDeferred = window.OneSignalDeferred || [];

	// Realiza el inicio de sesión
	login(email, password) {

        this.showLoader = true;

		this.afAuth.auth.signInWithEmailAndPassword(email, password)
			.then(
			    user => this.checarRolDeUsuario(user),
                error => {
                    alert('El correo electrónico/contraseña que ingresaste son incorrectos')
                    this.showLoader =false;
                });
	}
	actualizarNombre(usuario, departamento) {
		usuario.updateProfile({
			displayName: departamento,
		}).then(function () {

		}).catch(function (error) {
			//TODO Utilizar Log
		});
	}
	// Checa el tipo de usuario
	checarRolDeUsuario(usuario) {
        this.usuariosService.obtenerPropiedadDeUsuario(usuario.uid, 'informacionLaboral/estatusPersonal').valueChanges()
        .subscribe((estatus: string) => {
            if(estatus == 'Baja')
            {
                alert("Oops. Parece que este usuario ha sido desactivado.")
                this.afAuth.auth.signOut();
                this.usuariosService.auth = null;
                this.showLoader = false;
                this.route.navigateByUrl('/');
            }
            else {
                this.usuariosService.obtenerPropiedadDeUsuario(usuario.uid, 'informacionLaboral/departamento').valueChanges()
                    .subscribe((departamento: string) => {
                        try {
                            this.OneSignalDeferred.push(async function (OneSignal) {
                              await OneSignal.login(usuario.uid)
                              await OneSignal.User.addEmail(usuario.email)
                              await OneSignal.User.addTag("departamento", departamento);
                              console.log('OneSignal all Good')
                            });
                          }
                          catch (e) {
                            console.log(e)
                          }


                        this.showLoader =false;
                        window.localStorage.setItem("usuario.uid",usuario.uid);
                        window.localStorage.setItem("departamentoRolUsuario",departamento);
                        switch (departamento) {
                            case "GYO_Super_Admin":
                                this.actualizarNombre(usuario, 'ventas');
                                this.route.navigateByUrl('/ventas');
                                break;
                            case "Admin":
                                this.actualizarNombre(usuario, 'ventas');
                                this.route.navigateByUrl('/ventas');
                                break;
                            case "AGENCIA_EXTERNA":
                                this.actualizarNombre(usuario, 'agencia-externa');
                                this.route.navigateByUrl('/agencia-externa');
                                break;
                            case "Recursos Humanos":
                                this.actualizarNombre(usuario, 'recursos-humanos');
                                this.route.navigateByUrl('/recursos-humanos');
                                break;
                            case "Ventas":
                                this.actualizarNombre(usuario, 'ventas');
                                this.route.navigateByUrl('/ventas');
                                break;
                            case "Finanzas":
                                this.actualizarNombre(usuario, 'finanzas');
                                this.route.navigateByUrl('/finanzas');
                                break;
                            case "Planeación":
                                this.planeacionOmantenimiento = true;
                                alert("Estas ingresando al sistema antiguo, porfavor ingresa al nuevo panel de planeación y mantenimiento")
                                this.afAuth.auth.signOut();
                                this.usuariosService.auth = null;
                                this.route.navigateByUrl('/');
                            /*   this.actualizarNombre(usuario, 'planeacion');
                                this.route.navigateByUrl('/planeacion');*/
                                break;
                            case "Monitoreo":
                                this.actualizarNombre(usuario, 'monitoreo');
                                this.route.navigateByUrl('/monitoreo');
                                break;
                            case "Mantenimiento":
    /*                            this.planeacionOmantenimiento = true;
                                alert("Estas ingresando al sistema antiguo, porfavor ingresa al nuevo panel de planeación y mantenimiento")
                                this.afAuth.auth.signOut();
                                this.usuariosService.auth = null;
                                this.route.navigateByUrl('/');*/
                                this.actualizarNombre(usuario, 'mantenimiento');
                                this.route.navigateByUrl('/mantenimiento');
                                break;
                            default:
                                this.route.navigateByUrl('/clientes');
                                //alert('El usuario ingresado no pertenece a ningun departamento Activo');
                                break;
                        }
                    });
            }
        });

	}

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/components/login/login.component.ts